export const API =
  process.env.REACT_APP_API_URL ||
  (window.location.hostname === "localhost" ? "http://localhost:3001" : "");

export const ADMIN_TOKEN = process.env.REACT_APP_ADMIN_TOKEN || "";

export const WEDDING_DATE = "30.05.2026";
export const COUPLE_IMAGE = "/welcome_background.jpeg";
export const GALLERY_CACHE_KEY = "wedding_gallery_cache";
export const POLL_INTERVAL_MS = 30_000;
